import React, { useEffect, useRef, useState } from "react";
import {
  existsGeoUnit,
  geoDropdownById,
  geoFieldsById,
  updateGeoUnitById,
} from "../../api/geoHierarchyApi";
import Input from "../input/Input";
import Dropdown from "../input/Dropdown";
import SearchDropdown from "../input/SearchDropdown";
import {
  getBulkDropdownData,
  getFieldValuesByTableAndId,
} from "../../api/keyvalue";
import { countryStartsWith } from "../../api/countryApi";
import Button from "../input/Button";
import { toast } from "react-toastify";
import { AlertCircle, Plus, User } from "react-feather";
import InfoList from "../InfoList";
import Modal from "../Modal";

const GeoUnitsUpdateComponent = ({ selectedType, currentData }) => {
  const [formData, setFormData] = useState([]);
  const [paramState, setParamState] = useState({});
  const [searchFieldReset, setSearchFieldReset] = useState(false);
  const [active, setActive] = useState(1);
  const [activeOptions, setActiveOptions] = useState([]);
  const [countryFormData, setCountryFormData] = useState({});
  const [regionFormData, setRegionFormData] = useState({});
  const [dynamicFormData, setDynamicFormData] = useState({});
  const deleteWarningRef = useRef();
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);
  const [pendingSubmitEvent, setPendingSubmitEvent] = useState(null);

  const [formConfig, setFormConfig] = useState({
    gldId: null,
    geoUnitValue: "",
    lonLat: false,
    fields: [],
  });
  console.log("current data data", currentData.data);
  console.log("current data", currentData);

  const user = localStorage.getItem("username");
  console.log("user", user);

  const initParamState = (fields, countryId = null) => {
    const state = { param1: countryId };
    fields.forEach((_, index) => {
      state[`param${index + 2}`] = null;
    });
    return state;
  };

  console.log("selected type in update", selectedType);

  useEffect(() => {
    if (selectedType > 0) {
      geoFieldsById(selectedType)
        .then((data) => {
          setFormConfig({
            gldId: data.gldId,
            geoUnitValue: data.geoUnitValue,
            lonLat: data.lonLat,
            fields: data.fields || [],
          });
          setParamState(initParamState(data.fields));

          //resetForm();
        })
        .catch(console.error);
    }
  }, [selectedType]);

  useEffect(() => {
    (async () => {
      const { active, status } = await getBulkDropdownData([{ key: "active" }]);
      setActiveOptions(active);
    })();
  }, []);
  console.log("active", active);

  console.log("form config in update", formConfig);

  useEffect(() => {
    if (selectedType === -1 && currentData) {
      setCountryFormData({
        countryCode: currentData.couCode,
        countryName: currentData.couCountry,
        currenyCode: currentData.couIataCode,
        regionName: currentData.couRegionName,
        longitude: currentData.couLon,
        latitude: currentData.couLat,
        active: currentData.couActive,
      });
    } else if (selectedType == -2 && currentData) {
      setRegionFormData({
        regionName: currentData.regRegion,
        description: currentData.regDescription,
        regionCode: currentData.regCode,
        active: currentData.regActive,
      });
    }
  }, [selectedType, currentData]);

  const getDynamicFieldData = async () => {
    const dynamicData = {};
    for (let index = 0; index < formConfig.fields.length; index++) {
      const field = formConfig.fields[index];
      const fieldId = paramState[`param${index + 2}`];
      console.log("field", field);
      console.log("fieldId", fieldId);

      if (fieldId !== null) {
        const result = await getFieldValuesByTableAndId({
          tableName: field.tableName,
          primaryKey: field.primaryKey,
          fieldNames: field.fieldName,
          ids: fieldId.toString(),
        });

        dynamicData[field.name] = result[0]?.field1 || "";
      } else {
        dynamicData[field.name] = "";
      }
    }

    return dynamicData;
  };

  const handleResultSelect = (field, data, index) => {
    setDynamicFormData((prev) => ({ ...prev, [field.name]: data }));
    setParamState((prev) => {
      const newParams = { ...prev, [`param${index + 2}`]: data?.value || data };
      for (let i = index + 3; i <= formConfig.fields.length + 1; i++) {
        newParams[`param${i}`] = null;
      }
      return newParams;
    });
  };

  const handleClear = (field, index) => {
    setDynamicFormData((prev) => ({ ...prev, [field.name]: null }));
    setParamState((prev) => {
      const newParams = { ...prev, [`param${index + 2}`]: null };
      for (let i = index + 3; i <= formConfig.fields.length + 1; i++) {
        newParams[`param${i}`] = null;
      }
      return newParams;
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      if (selectedType > 0 && currentData?.data) {
        const rawData = currentData.data;
        if (!activeOptions.length) return;

        let countryName = "";
        if (rawData.param1) {
          const getCountryName = await getFieldValuesByTableAndId({
            tableName: "masterdata.tms_m_reg_country",
            primaryKey: "cou_id",
            fieldNames: "cou_country",
            ids: rawData.param1,
          });
          countryName = getCountryName[0]?.field1 || "";
        }

        let formData = {
          id: rawData.id,
          code: rawData.code,
          unitName: rawData.name,
          unitDescription: rawData.description,
          active:
            activeOptions.find((opt) => opt.value === rawData.active) || null,
          latitude: rawData.latitude || "",
          longitude: rawData.longitude || "",
          countryId: rawData.param1,
          countryName,
          createdBy: rawData.createdby,
          createdDate: rawData.createddate,
          lastModifiedBy: rawData.lastmodifiedby,
          lastModifiedDate: rawData.lastmodifieddate,
        };

        for (let idx = 0; idx < formConfig.fields.length; idx++) {
          const field = formConfig.fields[idx];
          const paramKey = `param${idx + 2}`;
          const paramValue = rawData[paramKey];

          if (paramValue) {
            formData[`${field.name}Id`] = paramValue;

            const result = await getFieldValuesByTableAndId({
              tableName: field.tableName,
              primaryKey: field.primaryKey,
              fieldNames: field.fieldName,
              ids: paramValue.toString(),
            });
            formData[`${field.name}Name`] = result[0]?.field1 || "";
          }
        }

        setDynamicFormData(formData);

        const params = Object.keys(rawData)
          .filter((key) => key.startsWith("param"))
          .reduce((acc, key) => {
            acc[key] = rawData[key];
            return acc;
          }, {});
        setParamState(params);
      }
    };

    fetchData();
  }, [selectedType, currentData, formConfig, activeOptions]);

  const resetForm = () => {
    setDynamicFormData({
      name: "",
      description: "",
      active: null,
      code: "",
      paramState: null,
    });
  };

  const handleUpdate = async (e, bypassDeleteCheck = false) => {
    e.preventDefault();
    if (!bypassDeleteCheck && dynamicFormData.active?.value === 2) {
      setPendingSubmitEvent(e);
      setShowDeleteWarning(true);
      deleteWarningRef.current?.showModal();
      return;
    }
    if (!dynamicFormData.unitName || dynamicFormData.unitName.trim() === "") {
      toast.error("Please Fill Name", {
        autoClose: 5000,
        containerId: "Main",
      });
      return;
    }
    if (dynamicFormData.unitName !== currentData?.data?.name) {
      const existsData = {
        name: dynamicFormData.unitName,
        params: { ...paramState },
      };

      const exists = await existsGeoUnit(formConfig.gldId, existsData);
      if (exists) {
        toast.error(`${dynamicFormData.unitName}" already exists`, {
          autoClose: 5000,
          containerId: "Main",
        });
        return;
      }
    }

    try {
      const payload = {
        name: dynamicFormData.unitName,
        description: dynamicFormData.unitDescription,
        active: dynamicFormData.active?.value,
        author: user,
        ...paramState,
      };

      const response = await updateGeoUnitById(
        formConfig.gldId,
        dynamicFormData.id,
        payload,
      );
      console.log("payload update ", payload);
      toast.success(`${formConfig.geoUnitValue} Updated Successfully`, {
        autoClose: 5000,
        containerId: "Main",
      });
      resetForm();
    } catch (e) {
      console.error(e);
      const errorMessage =
        e?.response?.data?.error || e?.message || "Update failed";
      toast.error(errorMessage, {
        autoClose: 5000,
        containerId: "Main",
      });
    }
  };
  const deleteWarningModal = (
    <div style={{ padding: "20px" }}>
      <h3 style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <AlertCircle color="red" size="25" />
        <p>Warning</p>
      </h3>
      <p>Active is set to Deleted. Are you sure you want to proceed?</p>
      <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
        <Button
          label="Cancel"
          onClick={() => {
            deleteWarningRef.current?.close();
            setShowDeleteWarning(false);
            setPendingSubmitEvent(null);
          }}
        />
        <Button
          label="Proceed"
          className="ui red button"
          onClick={() => {
            deleteWarningRef.current?.close();
            setShowDeleteWarning(false);
            setPendingSubmitEvent(null);
            handleUpdate({ preventDefault: () => {} }, true);
          }}
        />
      </div>
    </div>
  );

  console.log("dynamic formData state", dynamicFormData);
  console.log("state update ", selectedType);

  return (
    <div>
      <>
        <form className="ui form">
          <div className="ui segment">
            <h4 className="ui dividing header">
              {selectedType === -2
                ? "Update Region"
                : selectedType === -1
                  ? "Update Country"
                  : `Update ${formConfig.geoUnitValue}`}
            </h4>
            {/* country */}
            {selectedType == -1 && (
              <div>
                <div className="two fields">
                  <div className="seven wide field">
                    <Input
                      label="Country Code"
                      value={countryFormData.countryCode}
                      onChange={(e) =>
                        setCountryFormData((prev) => ({
                          ...prev,
                          countryCode: e.target.value,
                        }))
                      }
                      required
                      disabled={false}
                    />
                  </div>
                  <div className="seven wide field">
                    <Input
                      label="Country Name"
                      value={countryFormData.countryName}
                      onChange={(e) =>
                        setCountryFormData((prev) => ({
                          ...prev,
                          countryName: e.target.value,
                        }))
                      }
                      required
                      disabled={false}
                    />
                  </div>
                </div>

                <div className="two fields">
                  <div className="seven wide field">
                    <Input
                      label="Currency Code"
                      value={countryFormData.currenyCode}
                      onChange={(e) =>
                        setCountryFormData((prev) => ({
                          ...prev,
                          currenyCode: e.target.value,
                        }))
                      }
                      required
                      disabled={false}
                    />
                  </div>
                  <div className="seven wide field">
                    <Input
                      label="Region Name"
                      value={countryFormData.regionName}
                      onChange={(e) =>
                        setCountryFormData((prev) => ({
                          ...prev,
                          regionName: e.target.value,
                        }))
                      }
                      required
                      disabled={false}
                    />
                  </div>
                </div>
                <div className="two fields">
                  <div className="seven wide field">
                    <Input
                      label="Latitude"
                      type="number"
                      value={countryFormData.latitude}
                      onChange={(e) =>
                        setCountryFormData((prev) => ({
                          ...prev,
                          latitude: e.target.value,
                        }))
                      }
                      disabled={false}
                    />
                  </div>
                  <div className="seven wide field">
                    <Input
                      label="Longitude"
                      type="number"
                      value={countryFormData.longitude}
                      onChange={(e) =>
                        setCountryFormData((prev) => ({
                          ...prev,
                          longitude: e.target.value,
                        }))
                      }
                      disabled={false}
                    />
                  </div>
                </div>
                <div className="two fields">
                  <div className="seven wide field">
                    <Dropdown
                      label="Active"
                      disabled={false}
                      options={activeOptions}
                      value={countryFormData.active}
                      onChange={(e) =>
                        setCountryFormData((prev) => ({
                          ...prev,
                          active: e.target.value,
                        }))
                      }
                    />
                  </div>
                </div>
              </div>
            )}{" "}
            {/*  region */}
            {selectedType == -2 && (
              <div>
                <div className="two fields">
                  <div className="seven wide field">
                    <Input
                      label="Region Code"
                      type="text"
                      disabled={false}
                      value={regionFormData.regionCode}
                      onChange={(e) =>
                        setRegionFormData((prev) => ({
                          ...prev,
                          regionCode: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="seven wide field">
                    <Input
                      label="Name"
                      type="text"
                      value={regionFormData.regionName}
                      onChange={(e) =>
                        setRegionFormData((prev) => ({
                          ...prev,
                          regionName: e.target.value,
                        }))
                      }
                      disabled={false}
                    />
                  </div>
                </div>
                <div className="two fields">
                  <div className="seven wide field">
                    <Input
                      label="Description"
                      value={regionFormData.description}
                      onChange={(e) =>
                        setRegionFormData((prev) => ({
                          ...prev,
                          description: e.target.value,
                        }))
                      }
                      type="text"
                      disabled={false}
                    />
                  </div>
                  <div className="seven wide field">
                    <Dropdown
                      label="Active"
                      disabled={false}
                      options={activeOptions}
                      value={regionFormData.active}
                      onChange={(e) =>
                        setRegionFormData((prev) => ({
                          ...prev,
                          active: e.target.value,
                        }))
                      }
                    />
                  </div>
                </div>
              </div>
            )}{" "}
            {/*  state, dist, city...  ... */}
            {selectedType > 0 && (
              <div>
                <div className="two fields">
                  <div className="seven wide field">
                    <Input
                      label={`${formConfig.geoUnitValue} Code`}
                      type="text"
                      value={dynamicFormData.code}
                      onChange={(e) =>
                        setDynamicFormData((prev) => ({
                          ...prev,
                          code: e.target.value,
                        }))
                      }
                      disabled={true}
                    />
                  </div>
                  <div className="seven wide field">
                    <Input
                      label="Name"
                      value={dynamicFormData.unitName}
                      onChange={(e) =>
                        setDynamicFormData((prev) => ({
                          ...prev,
                          unitName: e.target.value,
                        }))
                      }
                      type="text"
                    />
                  </div>
                </div>
                <div className="two fields">
                  <div className="seven wide field">
                    <Input
                      label="Description"
                      value={dynamicFormData.unitDescription}
                      onChange={(e) =>
                        setDynamicFormData((prev) => ({
                          ...prev,
                          unitDescription: e.target.value,
                        }))
                      }
                      type="text"
                    />
                  </div>

                  <div className="seven wide field">
                    <Dropdown
                      label="Active"
                      options={activeOptions}
                      value={dynamicFormData.active?.value}
                      onChange={(e, data) =>
                        setDynamicFormData((prev) => ({
                          ...prev,
                          active: { value: data.value, label: data.text },
                        }))
                      }
                    />
                  </div>
                </div>
                <div className="two fields">
                  <div className="seven wide field">
                    <SearchDropdown
                      label="Country"
                      placeholder="Select Country"
                      fieldInfo={{
                        tableName: "masterdata.tms_m_reg_country",
                        primaryKey: "cou_id",
                        fieldName: "cou_country",
                        id: paramState.param1,
                      }}
                      api={countryStartsWith}
                      multiGrid={true}
                      multiGridCurrentValue={dynamicFormData.countryName}
                      value={dynamicFormData.countryId}
                      onResultSelect={(data) => {
                        setDynamicFormData((prev) => ({
                          ...prev,
                          country: data,
                        }));
                        setParamState((prev) => ({
                          ...initParamState(formConfig.fields, data),
                        }));
                      }}
                      onClear={() => {
                        setDynamicFormData((prev) => ({
                          ...prev,
                          country: null,
                        }));
                        setParamState(initParamState(formConfig.fields));
                      }}
                      reset={searchFieldReset}
                      setReset={setSearchFieldReset}
                      disabled={true}
                    />
                  </div>
                </div>
                <div className="two fields">
                  {formConfig.fields.map((field, index) => (
                    <div className="seven wide field">
                      <SearchDropdown
                        key={field.seq}
                        label={field.label}
                        placeholder={`Select ${field.label}`}
                        multiGrid={true}
                        multiGridCurrentValue={
                          dynamicFormData[`${field.name}Name`]
                        }
                        fieldInfo={{
                          tableName: field.tableName,
                          primaryKey: field.primaryKey,
                          fieldName: field.fieldName,
                          id: paramState[`param${index + 2}`],
                        }}
                        api={geoDropdownById}
                        apiDependency={{ id: field.gldId, params: paramState }}
                        value={dynamicFormData[`${field.name}Id`]}
                        onResultSelect={(data) =>
                          handleResultSelect(field, data, index)
                        }
                        onClear={() => handleClear(field, index)}
                        clearable
                        reset={searchFieldReset}
                        setReset={setSearchFieldReset}
                        disabled={true}
                      />
                    </div>
                  ))}
                </div>

                {formConfig.lonLat && (
                  <div className="two fields">
                    <div className="seven wide field">
                      <Input
                        label="Latitude"
                        placeholder="Latitude"
                        value={dynamicFormData.latitude}
                        onChange={(e) =>
                          setDynamicFormData((prev) => ({
                            ...prev,
                            latitude: e.target.value,
                          }))
                        }
                        disabled={true}
                      />
                    </div>
                    <div className="seven wide field">
                      <Input
                        label="Longitude"
                        placeholder="Longitude"
                        value={dynamicFormData.longitude}
                        onChange={(e) =>
                          setDynamicFormData((prev) => ({
                            ...prev,
                            longitude: e.target.value,
                          }))
                        }
                        disabled={true}
                      />
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          <InfoList
            title="User Information"
            content={[
              {
                title: "Created By",
                value:
                  currentData?.createdBy || dynamicFormData.createdBy || "N/A",
              },
              {
                title: "Created Date",
                value: currentData?.createdDate
                  ? new Date(currentData.createdDate).toLocaleDateString()
                  : dynamicFormData.createdDate
                    ? new Date(dynamicFormData.createdDate).toLocaleDateString()
                    : "N/A",
              },
              {
                title: "Last Modified By",
                value:
                  currentData?.lastModifiedBy ||
                  dynamicFormData.lastModifiedBy ||
                  "N/A",
              },
              {
                title: "Last Modified Date",
                value: currentData?.lastModifiedDate
                  ? new Date(currentData.lastModifiedDate).toLocaleDateString()
                  : dynamicFormData.lastModifiedDate
                    ? new Date(
                        dynamicFormData.lastModifiedDate,
                      ).toLocaleDateString()
                    : "N/A",
              },
            ]}
            Icon={User}
          />
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "30px",
              }}
            >
              {" "}
              {/* update */}
              <Button
                onClick={handleUpdate}
                disabled={selectedType == -2 || selectedType == -1}
                label="Update"
                Icon={Plus}
              />
            </div>
          </div>
        </form>
        <Modal ref={deleteWarningRef} closeButton={false} minWidth={"300px"}>
          {showDeleteWarning && deleteWarningModal}
        </Modal>
      </>
    </div>
  );
};

export default GeoUnitsUpdateComponent;
